export default {
  pluginID: 'metrics-collector',
};
